export default __webpack_public_path__ + "static/media/right_fish.66bb305f.svg";